import { Vue, Component, Prop } from 'vue-property-decorator'

import { PlaceholdersOnes, PlaceholdersStack } from '../components/Toolbar/types'

@Component
export default class EditorProps extends Vue {
  @Prop() readonly placeholders!: PlaceholdersOnes | PlaceholdersStack

  @Prop() readonly disabledPanelElements?: Array<string>

  @Prop({ type: Number, default: 4096 }) readonly counterMax!: number

  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  @Prop({ type: Boolean, default: false, required: false }) trimEnd!: boolean
}
